import { SortType } from '../../Model/Sort';
export var EncSort;
(function (EncSort) {
    EncSort.ByAlpha = {
        make(source, descending = false) {
            return {
                type: SortType.ALPHA,
                source,
                descending,
            };
        },
    };
    EncSort.ByData = {
        make(source, descending = false) {
            return {
                type: SortType.DATA,
                source,
                descending,
            };
        },
    };
    EncSort.ByField = {
        make(source, byField, descending = false) {
            return {
                type: SortType.FIELD,
                source,
                byField,
                descending,
            };
        },
    };
    EncSort.ByNested = {
        make(field, source, byField, descending = false) {
            return {
                type: SortType.NESTED,
                field,
                source,
                byField,
                descending,
            };
        },
    };
    EncSort.ByManual = {
        make(source, items, descending = false) {
            return {
                type: SortType.MANUAL,
                source,
                items,
                descending,
            };
        },
    };
})(EncSort || (EncSort = {}));
